export default __webpack_public_path__ + "static/media/sanmat8.1a8e27a9.jpg";